'use strict';

module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src946329470/src/frontend/~/chart.js/src/charts/Chart.Scatter.js
// module id = ../../../../chart.js/src/charts/Chart.Scatter.js
// module chunks = 4